import { t } from 'i18next';

import type { GameProviderName } from '../../stores/game/types';
import type { FreeSpinWidgetGameType } from '../../stores/user-free-spins/types';

export function getTextsByMinigameType(
  provider: GameProviderName,
  gameType?: FreeSpinWidgetGameType,
  freeSpinType?: 'AWARDED_FEATURE' | 'FREE_ROUNDS' | null,
) {
  if (['Barouletta Gaming', 'Minigames'].includes(provider)) {
    if (gameType?.startsWith('RiveMinigameV2')) {
      // Per-contract copy resolves via i18next context: `value_<gameType>` if present, else the base
      // `value`. Adding a contract needs only new i18n keys, no code and no per-key defaultValue.
      return {
        title: t('userFreeSpins.title.value', { context: gameType }),
        subTitle: t('userFreeSpins.subtitle.value', { context: gameType }),
        // crown the "o" — present in both the per-contract titles and the fallback ("SPIN YOUR WHEEL!" → "YOUR")
        titleCrownLetters: ['o'],
        fontSize: '30px',
      };
    }

    switch (gameType) {
      case 'wheel': {
        return {
          title: t('userFreeSpins.wheelPrize'),
          subTitle: t('userFreeSpins.spinsAreWaiting'),
          titleCrownLetters: ['i'],
          fontSize: '30px',
        };
      }
      case 'minesweeper': {
        return {
          title: t('userFreeSpins.crownMiner'),
          subTitle: t('userFreeSpins.crownMinerSubtitle'),
          titleCrownLetters: ['o'],
        };
      }
      case 'plinko': {
        return {
          title: t('userFreeSpins.plincrownAwaits'),
          subTitle: t('userFreeSpins.freeGameJustForYou'),
          titleCrownLetters: ['o'],
        };
      }
      case 'scratchcrown': {
        return {
          title: t('userFreeSpins.scratchcrown'),
          subTitle: t('userFreeSpins.readyToScratch'),
          titleCrownLetters: ['o'],
          fontSize: '32px',
        };
      }
      case 'clawmachine': {
        return {
          title: t('userFreeSpins.crownClaw'),
          subTitle: t('userFreeSpins.crownClawSubtitle'),
          titleCrownLetters: ['o'],
        };
      }
      case 'crownpop': {
        return {
          title: t('userFreeSpins.crownPop'),
          subTitle: t('userFreeSpins.crownPopSubtitle'),
          titleCrownLetters: ['o'],
        };
      }
      case 'minigameroulette': {
        return {
          title: t('userFreeSpins.minigameRouletteTitle'),
          subTitle: t('userFreeSpins.minigameRouletteSubtitle'),
          titleCrownLetters: ['o'],
          fontSize: '30px',
        };
      }
      case 'pickgame': {
        return {
          title: t('userFreeSpins.pickgameTitle'),
          subTitle: t('userFreeSpins.pickgameSubtitle'),
          titleCrownLetters: ['o'],
          fontSize: '30px',
        };
      }
      case 'crownstriker': {
        return {
          title: t('userFreeSpins.crownStrikerTitle'),
          subTitle: t('userFreeSpins.crownStrikerSubtitle'),
          titleCrownLetters: ['o'],
          fontSize: '30px',
        };
      }
      case 'crownrise': {
        return {
          title: t('userFreeSpins.crownRiseTitle'),
          subTitle: t('userFreeSpins.crownRiseSubtitle'),
          titleCrownLetters: ['o'],
          fontSize: '30px',
        };
      }
      default: {
        // currently only some of wheel of fortune games dont have a gameType
        return {
          title: t('userFreeSpins.wheelPrize'),
          subTitle: t('userFreeSpins.spinsAreWaiting'),
          titleCrownLetters: ['i'],
          fontSize: '30px',
        };
      }
    }
  } else {
    if (freeSpinType === 'AWARDED_FEATURE') {
      return {
        title: 'PLAY FEATURE!',
        subTitle: 'JUMP INTO THE BONUS ROUND!',
        titleCrownLetters: ['p'],
      };
    }

    return {
      title: t('userFreeSpins.freeSpins'),
      subTitle: t('userFreeSpins.spinsAreWaiting'),
      titleCrownLetters: ['i'],
    };
  }
}
